<template>
  <header :class="{'menu-open': stores.page.menuOpen}">
    <div class="nav-toggle" v-on:click.prevent="toggleMenu">
      <template v-if="currentNav">
        <i v-if="currentNav.icon" :class="`${currentNav.icon} icon-color-${currentNav.color}`"></i>
        {{ currentNav.title }}
      </template>
    </div>
    <div class="page-title">
      <HeadClientSelect />
      <ul class="breadcrumbs" v-if="false && pageBreadcrumbs.length">
        <li>
          <router-link :to="{name:'page',params:{path:''}}">
            <i class="fa-solid fa-house"></i>
          </router-link>
        </li>
        <li v-for="item in pageBreadcrumbs">
          <router-link v-if="item" :to="item.link">{{ item.title }}</router-link>
        </li>
      </ul>
    </div>
<!--    <a href="/" target="_blank" class="logo">
      <img src="static/img/demostore-logo.png" :alt="storeName" />
    </a> -->
    <div class="usermenu" v-if="currentUser">
      <span class="msg">{{ currentUser.username }}</span>
      <div class="rolebox">
        <div class="user-img-container"><i class="fa-solid fa-user"></i></div>
<!--         <span class="role">{{ currentUser.group }}</span> -->
      </div>
      <router-link class="btn" :to="'/User/'+currentUser.uuid">Profil</router-link>
      <a class="btn btn-danger" v-on:click.prevent="doLogout">Odjava</a>
    </div>
    <section class="page-current">
      <h2>{{ pageTitle }}</h2>
    </section>
  </header>
</template>


<script>
export default {
  computed: {
    storeName() {
      return this.stores.auth.cms?.storeName;
    },
    currentNav() {
      var path=this.$route.params.path || [];
      var activePathType=path[(path.length-1) & ~0x1];
      var activePathId=path[(path.length-1) & ~0x1 | 0x1];
      for(var navItem of this.stores.nav.items || []) {
        if (navItem.path[0]==activePathType)
          if (!navItem.path[1] || navItem.path[1]==activePathId)
            return navItem;
        for(var subItem of navItem.items || []) {
          if (subItem.path[0]==activePathType)
            if (!subItem.path[1] || subItem.path[1]==activePathId)
              return subItem;
        }
      }
      return null;
    },
    currentUser() {
      return this.stores.auth.currentUser;
    },
    pageTitle() {
      return this.stores.page.title;
    },
    pageBreadcrumbs() {
      return this.stores.page.breadcrumbs || [];
    },
  },
  methods: {
    doLogout() {
      this.stores.auth.logout();
    },
    toggleMenu() {
      this.stores.page.menuOpen=!this.stores.page.menuOpen;
    },
  }
}
</script>
